;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import * as yup from 'yup';

export const validationSchema = yup.object({ receiveMatchmail: yup.boolean() });

export type EmailSettingsInputs = yup.InferType<typeof validationSchema>;

export const initialValues: EmailSettingsInputs = { receiveMatchmail: false };
